"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionBillingInterval = void 0;
var SubscriptionBillingInterval;
(function (SubscriptionBillingInterval) {
    SubscriptionBillingInterval["MONTH"] = "month";
    SubscriptionBillingInterval["YEAR"] = "year";
})(SubscriptionBillingInterval || (exports.SubscriptionBillingInterval = SubscriptionBillingInterval = {}));
//# sourceMappingURL=BillingInterval.js.map